import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./Register.css";

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    affiliation: "",
    industries: []
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleIndustryChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      industries: checked 
        ? [...prev.industries, value]
        : prev.industries.filter(industry => industry !== value)
    }));
  };

  const validateForm = () => {
    if (!formData.fullName || !formData.email || !formData.password || 
        !formData.confirmPassword || !formData.affiliation || 
        formData.industries.length === 0) {
      toast.error("Please fill out all fields.");
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match.");
      return false;
    }

    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          password: formData.password,
          industries: formData.industries,
          governmentAffiliation: formData.affiliation
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || "Registration failed");
      }

      toast.success("Registration successful! Please log in with your credentials.");
      
      // Redirect to login page
      navigate("/login");
      
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(error.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page" style={{ backgroundImage: `url()` }}>
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Register & Subscribe</h2>
        
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleInputChange}
          required
        />
        
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        
        <input
          type="password"
          name="password"
          placeholder="Password (min 6 characters)"
          value={formData.password}
          onChange={handleInputChange}
          required
        />
        
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={handleInputChange}
          required
        />
        
        <select
          name="affiliation"
          value={formData.affiliation}
          onChange={handleInputChange}
          required
        >
          <option value="">Select Government Affiliation</option>
          <option value="Federal">Federal</option>
          <option value="State">State</option>
          <option value="Local">Local</option>
        </select>

        <div className="industry-selection">
          <label className="industry-label">Select Industries (at least one):</label>
          <div className="industry-options">
            <label>
              <input 
                type="checkbox" 
                value="Accounting" 
                onChange={handleIndustryChange}
                checked={formData.industries.includes("Accounting")}
              /> 
              Accounting
            </label>
            <label>
              <input 
                type="checkbox" 
                value="Finance" 
                onChange={handleIndustryChange}
                checked={formData.industries.includes("Finance")}
              /> 
              Finance
            </label>
            <label>
              <input 
                type="checkbox" 
                value="Healthcare" 
                onChange={handleIndustryChange}
                checked={formData.industries.includes("Healthcare")}
              /> 
              Healthcare
            </label>
            <label>
              <input 
                type="checkbox" 
                value="Technology" 
                onChange={handleIndustryChange}
                checked={formData.industries.includes("Technology")}
              /> 
              Technology
            </label>
          </div>
        </div>
        
        <button 
          type="submit" 
          className="register-button"
          disabled={loading}
        >
          {loading ? "Registering..." : "Register & Subscribe"}
        </button>

        <p className="login-link">
          Do you already have an account? <a href="/login">Log in here</a>
        </p>
      </form>
    </div>
  );
};

export default Register;






// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "./Register.css";

// const Register = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//     affiliation: "",
//     industries: []
//   });
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleIndustryChange = (e) => {
//     const { value, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       industries: checked 
//         ? [...prev.industries, value]
//         : prev.industries.filter(industry => industry !== value)
//     }));
//   };

//   const validateForm = () => {
//     if (!formData.fullName || !formData.email || !formData.password || 
//         !formData.confirmPassword || !formData.affiliation || 
//         formData.industries.length === 0) {
//       toast.error("Please fill out all fields.");
//       return false;
//     }

//     if (formData.password !== formData.confirmPassword) {
//       toast.error("Passwords do not match.");
//       return false;
//     }

//     if (formData.password.length < 6) {
//       toast.error("Password must be at least 6 characters long.");
//       return false;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       toast.error("Please enter a valid email address.");
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:8000/api/register", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           name: formData.fullName,
//           email: formData.email,
//           password: formData.password,
//           industries: formData.industries,
//           governmentAffiliation: formData.affiliation
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.error || data.message || "Registration failed");
//       }

//       toast.success("Registration successful! Please log in with your credentials.");
      
//       // Redirect to login page
//       navigate("/login");
      
//     } catch (error) {
//       console.error("Registration error:", error);
//       toast.error(error.message || "Registration failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="register-page" style={{ backgroundImage: `url()` }}>
//       <form className="register-form" onSubmit={handleSubmit}>
//         <h2>Register & Subscribe</h2>
        
//         <input
//           type="text"
//           name="fullName"
//           placeholder="Full Name"
//           value={formData.fullName}
//           onChange={handleInputChange}
//           required
//         />
        
//         <input
//           type="email"
//           name="email"
//           placeholder="Email Address"
//           value={formData.email}
//           onChange={handleInputChange}
//           required
//         />
        
//         <input
//           type="password"
//           name="password"
//           placeholder="Password (min 6 characters)"
//           value={formData.password}
//           onChange={handleInputChange}
//           required
//         />
        
//         <input
//           type="password"
//           name="confirmPassword"
//           placeholder="Confirm Password"
//           value={formData.confirmPassword}
//           onChange={handleInputChange}
//           required
//         />
        
//         <select
//           name="affiliation"
//           value={formData.affiliation}
//           onChange={handleInputChange}
//           required
//         >
//           <option value="">Select Government Affiliation</option>
//           <option value="Federal">Federal</option>
//           <option value="State">State</option>
//           <option value="Local">Local</option>
//         </select>

//         <div className="industry-selection">
//           <label className="industry-label">Select Industries (at least one):</label>
//           <div className="industry-options">
//             <label>
//               <input 
//                 type="checkbox" 
//                 value="Accounting" 
//                 onChange={handleIndustryChange}
//                 checked={formData.industries.includes("Accounting")}
//               /> 
//               Accounting
//             </label>
//             <label>
//               <input 
//                 type="checkbox" 
//                 value="Finance" 
//                 onChange={handleIndustryChange}
//                 checked={formData.industries.includes("Finance")}
//               /> 
//               Finance
//             </label>
//             <label>
//               <input 
//                 type="checkbox" 
//                 value="Healthcare" 
//                 onChange={handleIndustryChange}
//                 checked={formData.industries.includes("Healthcare")}
//               /> 
//               Healthcare
//             </label>
//             <label>
//               <input 
//                 type="checkbox" 
//                 value="Technology" 
//                 onChange={handleIndustryChange}
//                 checked={formData.industries.includes("Technology")}
//               /> 
//               Technology
//             </label>
//           </div>
//         </div>
        
//         <button 
//           type="submit" 
//           className="register-button"
//           disabled={loading}
//         >
//           {loading ? "Registering..." : "Register & Subscribe"}
//         </button>

//         <p className="login-link">
//           Already have an account? <a href="/login">Log in here</a>
//         </p>
//       </form>
//     </div>
//   );
// };

// export default Register;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "./Register.css"; // Ensure the CSS path is correct
// // import backgroundImage from "../components/Assets/registerPage.jpg"; // Make sure the path is updated

// const Register = () => {
//   const navigate = useNavigate();
//   const [fullName, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [affiliation, setAffiliation] = useState("");

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (!fullName || !email || !affiliation) {
//       toast.error("Please fill out all fields.");
//       return;
//     }
//     // You can redirect or perform further actions here upon successful registration
//     navigate("/registration-success");
//     toast.success("Registration successful!");
//   };

//   return (
//     <div className="register-page" style={{ backgroundImage: `url()` }}> {/* Consider updating the backgroundImage URL */}
//       <form className="register-form" onSubmit={handleSubmit}>
//         <input
//           type="text"
//           placeholder="Full Name"
//           value={fullName}
//           onChange={(e) => setFullName(e.target.value)}
//           required
//         />
//         <input
//           type="email"
//           placeholder="Email Address"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />
//         <select
//           value={affiliation}
//           onChange={(e) => setAffiliation(e.target.value)}
//           required
//         >
//           <option value="">Select Government Affiliation</option>
//           <option value="state">State</option>
//           <option value="federal">Federal</option>
//           <option value="local">Local</option>
//         </select>
//         <button type="submit" className="register-button">
//           Register
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Register;



// import React, { useState } from "react";
// import { useHistory } from "react-router-dom";
// import { toast } from "react-toastify";
// import "./Register.css"; // Ensure the CSS path is correct
// // import backgroundImage from "../components/Assets/registerPage.jpg"; // Make sure the path is updated

// const Register = () => {
//   const history = useHistory();
//   const [fullName, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [affiliation, setAffiliation] = useState("");

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (!fullName || !email || !affiliation) {
//       toast.error("Please fill out all fields.");
//       return;
//     }
//     // You can redirect or perform further actions here upon successful registration
//     history.push("/registration-success");
//     toast.success("Registration successful!");
//   };

//   return (
//     <div className="register-page" style={{ backgroundImage: `url()` }}>
//       <form className="register-form" onSubmit={handleSubmit}>
//         <input
//           type="text"
//           placeholder="Full Name"
//           value={fullName}
//           onChange={(e) => setFullName(e.target.value)}
//           required
//         />
//         <input
//           type="email"
//           placeholder="Email Address"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />
//         <select
//           value={affiliation}
//           onChange={(e) => setAffiliation(e.target.value)}
//           required
//         >
//           <option value="">Select Government Affiliation</option>
//           <option value="state">State</option>
//           <option value="federal">Federal</option>
//           <option value="local">Local</option>
//         </select>
//         <button type="submit" className="register-button">
//           Register
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Register;

